import styled from 'styled-components';
import InputMask from 'react-input-mask';

// CONSTANTS
import { responsiveEndPoints } from '../../constants/responsive-endpoints';
import { theme } from '../../constants/theme';

// INTERFACES
import { IInput } from '../../interfaces/Input.interface';

export const Container = styled.div`
  display: inline-flex;
  position: relative;
  flex-wrap: wrap;
  width: 100%;
  margin-bottom: 16px;
  flex-direction: column;
`;

export const Label = styled.label<IInput>`
  display: inline-block;
  font-family: 'Clan Pro';
  font-weight: ${theme.weights.semibold};
  color: ${theme.colors.secondary.gray100};
  font-size: 12px;
  line-height: 22px;
  ${({ haserror }) =>
    haserror &&
    `
    color: ${theme.colors.secondary.gray200};
  `}

  ${({ isDisabled }) =>
    isDisabled &&
    `
    color: ${theme.colors.secondary.gray300};
  `}
`;

export const SubLabelText = styled.p<IInput>`
  display: flex;
  justify-content: space-between;
  font-family: 'Clan Pro';
  font-weight: ${theme.weights.semibold};
  font-size: 12px;
  line-height: 22px;
  color: ${theme.colors.secondary.gray300};
  margin: 0 0 8px 0;
`;

export const InputContainer = styled.div`
  display: block;
`;

export const StyledInput = styled(InputMask)<IInput>`
  padding: 16px;
  outline: 0;
  display: inline-block;
  width: 100%;
  max-width: 100%;
  background: ${theme.colors.primary.white};
  border: 1px solid ${theme.colors.secondary.gray500};
  box-sizing: border-box;
  border-radius: 8px;
  font-family: 'Clan Web Pro News', sans-serif;
  font-size: 14px;
  line-height: 24px;
  color: ${theme.colors.secondary.gray300};
  &:active {
    color: ${theme.colors.primary.black};
    border-color: ${theme.colors.secondary.blue200};
  }
  &:disabled {
    color: ${theme.colors.secondary.gray300};
    border-color: ${theme.colors.secondary.gray500};
    background: ${theme.colors.primary.lightGray};
  }
  &:valid {
    color: ${theme.colors.primary.black};
    border-color: ${theme.colors.secondary.gray500};
  }
  &:focus {
    color: ${theme.colors.secondary.gray300};
    border: 1px solid ${theme.colors.secondary.blue200};
    box-shadow: 0px 0px 0px 2px ${theme.colors.secondary.blue500};
  }
  &:not(:focus) {
    ${({ haserror }) =>
      haserror &&
      `
    border-color: ${theme.colors.secondary.red200} !important;
  `}
  }
`;

export const Error = styled.span`
  display: flex;
  color: ${theme.colors.secondary.red200};
  font-family: 'Clan Pro';
  font-weight: ${theme.weights.semibold};
  font-size: 12px;
  line-height: 22px;
  margin-bottom: 8px;
`;

export const CheckMarkContainer = styled.div`
  position: absolute;
  width: 2rem;
  height: 2rem;
  bottom: 13px;
  right: 16px;
`;

export const ComponentTooltip = styled.div`
  position: relative;
  display: inline-block;
  :hover {
    span {
      visibility: visible;
    }
  }
`;

export const MessageTooltipText = styled.span`
  visibility: hidden;
  background: #101010;
  width: 196px;
  color: #ffffff;
  text-align: center;
  font-size: 11px;
  line-height: 16px;
  font-family: 'Clan Pro';
  font-weight: ${theme.weights.regular};
  position: absolute;
  z-index: 1;
  box-shadow: 0px 34px 30px -20px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  padding: 8px 24px;
  bottom: 130%;
  left: 57%;
  margin-left: -104px;

  &::after {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: 0;
    border-width: 5px;
    border-style: solid;
    border-color: #101010 transparent transparent transparent;
    right: 88px;
  }

  @media (max-width: ${responsiveEndPoints.mobile}px) {
    right: 144%;
    left: auto;
    margin-left: 0;
    bottom: -9px;

    &::after {
      top: 40%;
      left: auto;
      border-color: transparent transparent transparent #101010;
      bottom: 50%;
      right: -10px;
    }
  }
`;

export const LoaderContent = styled.div`
  position: absolute;
  right: 10px;
  bottom: 14px;
  background-color: #ffffff;
`;
